// @react/hooks/useCalendarCalendarEventType.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { calendarCalendarEventTypeStore } from '@core/stores';

/**
 * React hook for CalendarEventTypeDefinition operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useCalendarCalendarEventType } from '@react/hooks';
 *
 * const CalendarEventTypeDefinitionList = observer(() => {
 *   const store = useCalendarCalendarEventType();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useCalendarCalendarEventType() {
  return calendarCalendarEventTypeStore;
}
